import axios from '@/extensions/axios'

const actions = {
  get ({ commit }, queryParams) {
    return axios.get('users', {
      params: queryParams
    }).then((request) => {
      commit('SET', request)
      return request.data
    })
  },

  getById ({ commit }, id) {
    return axios.get('users/' + id)
      .then(({ data }) => {
        commit('ADD', data)
        commit('SET_NEW', data)
        return data
      })
  },

  create ({ state }) {
    return axios.post('users', state.newUser)
  },

  save ({ state }) {
    let user = state.newUser
    return axios.put('users/' + user.id, user)
  },

  changeUserPassword ({ state }, { newPassword, newPasswordRepeat }) {
    return axios.put('users/' + state.newUser.id + '/change-password', {
      newPassword,
      newPasswordRepeat
    })
  },

  changePassword ({ state }, { newPassword, newPasswordRepeat, oldPassword }) {
    return axios.put('users/change-password', {
      oldPassword,
      newPassword,
      newPasswordRepeat
    })
  },

  getRoles ({ state, commit }) {
    return axios.get('users/' + state.newUser.id + '/roles')
      .then(({ data }) => {
        commit('SET_ASSIGNED_ROLES', data)
        commit('SET_ROLES', data)
      })
  },

  saveRoles ({ state, commit }) {
    const assigned = state.assignedRoles.map(role => role.name)
    const selected = state.selectedRoles.map(role => role.name)
    const promises = []
    assigned.forEach(role => {
      if (!selected.includes(role)) {
        promises.push(
          axios.put('users/' + state.newUser.id + '/revoke-role', {
            role: role
          })
        )
      }
    })
    selected.forEach(role => {
      if (!assigned.includes(role)) {
        promises.push(
          axios.put('users/' + state.newUser.id + '/assign-role', {
            role: role
          })
        )
      }
    })
    return Promise.all(promises).then(() => {
      commit('SET_ASSIGNED_ROLES', state.selectedRoles)
    })
  },

  getSites ({ state, commit }) {
    return axios.get('users/' + state.newUser.id + '/sites')
      .then(({ data }) => {
        commit('SET_ASSIGNED_SITES', data)
        commit('SET_SITES', data)
      })
  },

  saveSites ({ state, commit }) {
    const assigned = state.assignedSites.map(site => site.slug)
    const selected = state.selectedSites.map(site => site.slug)
    const promises = []
    assigned.forEach(site => {
      if (!selected.includes(site)) {
        promises.push(
          axios.delete('users/' + state.newUser.id + '/sites/' + site)
        )
      }
    })
    selected.forEach(site => {
      if (!assigned.includes(site)) {
        promises.push(
          axios.post('users/' + state.newUser.id + '/sites', {
            siteSlug: site
          })
        )
      }
    })
    return Promise.all(promises).then(() => {
      commit('SET_ASSIGNED_SITES', state.selectedSites)
    })
  },

  remove ({ state }) {
    return axios.delete('users/' + state.newUser.id)
  }
}

export default actions
